var map = {
	"./logo-footer.png": 49046,
	"./ricons.svg": 63338,
	"./riihimaki-logo-red.svg": 25203,
	"./rsign-border.svg": 21984,
	"./rsign-puzzle.svg": 31414,
	"./rsign-red.svg": 70780,
	"./rsign-square-red.svg": 4542,
	"./rsign-square-white.svg": 49980,
	"./rsign-white.svg": 12807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48999;